import { MaybeRef } from '@vueuse/core'
import { unref } from 'vue'

type UseOdometerRulesReturn = {
  beforeEnd: (val: number) => boolean
  beforeStart: (val: number) => boolean
  noDecimal: (val: number) => boolean
  all: () => boolean
  /**This does not return under all, since its still valid. */
  greaterThan: (distance: number) => (start: number, end: number) => boolean
}
export const useOdometerRules = (input: {
  start: MaybeRef<number>
  end: MaybeRef<number>
}): UseOdometerRulesReturn => {
  const beforeEnd = (val: number) => {
    return !!(val < unref(input.end))
  }
  const beforeStart = (val: number) => {
    return !!(val > unref(input.start))
  }

  const greaterThan = (distance: number) => (start: number, end: number) => end - start >= distance

  const noDecimal = (val: number) => val % 1 === 0 

  const all = () => {
    return beforeEnd(unref(input.start)) && beforeStart(unref(input.end)) && noDecimal(unref(input.start)) && noDecimal(unref(input.end))
  }
  return {
    beforeEnd,
    beforeStart,
    all,
    noDecimal,
    greaterThan,
  }
}
